export const OTHER_CHARGES_ANNUAL_EUR_PER_STORE = 15_000

export interface NetworkContributionDetailSelectionParams {
  storeIds?: number[]
  storeAgeFilter?: string
  ageStoreIds?: number[]
  startDate?: string
  endDate?: string
  comparableStartDate?: string
  comparableEndDate?: string
}

export interface NetworkContributionMetrics {
  caTtcEur: number
  caHtEur: number
  mbEur: number
  casseEur: number
  volEur: number
  staffCostEur: number
  rentEur: number
  logisticEur: number
  otherChargesEur: number
  contributionEur: number
  mbPercent: number | null
  cassePercent: number | null
  volPercent: number | null
  mbcPercent: number | null
  staffCostPercent: number | null
  rentPercent: number | null
  logisticPercent: number | null
  otherChargesPercent: number | null
  contributionPercent: number | null
}

export interface NetworkContributionStoreRow {
  storeId: number
  period: NetworkContributionMetrics
  comparable: NetworkContributionMetrics | null
}

export interface NetworkContributionTotal {
  storeCount: number
  period: NetworkContributionMetrics
  comparable: NetworkContributionMetrics | null
}

export interface NetworkContributionDetail {
  periodStart: string
  periodEnd: string
  compStart: string
  compEnd: string
  stores: NetworkContributionStoreRow[]
  total: NetworkContributionTotal
}
